module.exports = __webpack_public_path__ + "static/media/3.tapingAreaDesc.8fce95c3.webp";